module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_04_6DC79_1SD_HAV.38e51c50.jpg";